import { useHistory } from 'react-router-dom';
import { useTranslation } from '@eti/providers';
import { css } from '@eti/styles';
import { DangerousHtmlContent } from '@eti/components';
import { breakpoints } from '@etg/wings';
import { routes } from '../../../constants/routesAndApisConstants';
import PageSection from '../../order-details/components/common/PageSection';

const buttonsWrapperStyles = css`
  @media (min-width: ${breakpoints._768}) {
    justify-content: flex-start;
  }
`;

const descriptionStyles = css`
  margin-bottom: 10px;
`;

const Refund = () => {
  const history = useHistory();
  const { t } = useTranslation();

  const redirectToOrderList = () => {
    history.push(routes.ORDER_LIST);
  };

  const refundStatusButton = {
    text: t('ContactUs.RefundSection.Button'),
    onClick: redirectToOrderList,
    dataTestId: 'contactUs-refundStatus-button',
    variant: 'secondary',
  };

  return (
    <PageSection heading={{ title: t('ContactUs.RefundSection.Title') }}>
      <PageSection.Body
        buttons={[refundStatusButton]}
        buttonsLayout="horizontal"
        classNames={{ buttonsWrapper: buttonsWrapperStyles }}
        dataTestId="refund-page-section"
      >
        <DangerousHtmlContent
          className={descriptionStyles}
          content={t('ContactUs.RefundSection.Description')}
        />
      </PageSection.Body>
    </PageSection>
  );
};

export default Refund;
